import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ShipmentType } from "../enums/_index";

export class UpdateCustomsRequest {

    public type : ShipmentType;

    // FYI the routes rowVersion
    @ValidateProperty({ required: true })
    public rowVersion : string = '';

}

        export class TruckCustomsEntry {
            
            public stopId : number;
            
            public parsNumber : string = '';

            constructor(id : number, parsNumber : string) {
                this.stopId = id;
                this.parsNumber = parsNumber;
            }

        }

        export class UpdateTruckCustomsRequest extends UpdateCustomsRequest {

            public portofEntryId : number|undefined = undefined;

            @ValidateProperty({ required: true })
            public stops : TruckCustomsEntry[] = [];

            constructor() {
                super();
                this.type = ShipmentType.Truck;
            }

        }

        export class UpdateContainerCustomsRequest extends UpdateCustomsRequest {
            
            public seal : string;
            
            public tareWeight : number|undefined = undefined;
            
            public loadedWeight : number|undefined = undefined;
            
            public unloadedWeight : number|undefined = undefined;
            
            constructor() {
                super();
                this.type = ShipmentType.Container;
            }
            
        }
